import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { ReadOnlyTextField } from 'components/Shared/ReadOnlyTextField'
import { fetchDriver } from 'services'

export function InternalDriver ({ driverId }) {
  const { t } = useTranslation()

  const [driver, setDriver] = useState(null)

  useEffect(() => {
    if(driverId) {
      fetchDriver(driverId).then(driver => setDriver(driver))
    } else {
      setDriver(null)
    }
  }, [driverId])


  return (
    <>
      <div className='d-flex flex-column'>
        <ReadOnlyTextField
          disabled
          variantValue={'filled'}
          value={driver ? driver.firstName + ' ' + driver.lastName : ''}
          label={t('form.order.carrier.driver.driverDetails')}
        />
      </div>
    </>
  )
}
